import { observer } from 'mobx-react'
import React from 'react'
import WhyNoSir from 'shared-components/WhyNoSir/WhyNoSir'
import LendVM from '../LendVM'
import UserYieldsItem from './UserYieldsItem'

export function UserYields({ vm }: { vm: LendVM }) {
  const { userYields } = vm.lendStore

  if (userYields.loaded && userYields.value.length === 0) {
    return <WhyNoSir text="Why no lend, ser?" buttonText="Lend Now" link="/lend/asset" />
  }

  return (
    <div className="lend-user-yields margin-top-2 margin-bottom-4">
      {vm.filteredYieldList.map((yyield) => (
        <UserYieldsItem key={yyield.asset} lendItem={yyield} vm={vm} />
      ))}

      {/** Trick to align items with tabs when there is only one */}
      {vm.filteredYieldList.length === 1 && <div />}

      {vm.filteredYieldList.length === 0 && vm.searchQuery && (
        <p className="txt-center margin-top-2">
          <i>The filter returned 0 result.</i>
        </p>
      )}
    </div>
  )
}

export default observer(UserYields)
